import React, { useContext, useEffect, useState } from "react"
import moment from "moment-timezone"
import qs from "query-string"
import { getField } from "./formField"
import { Tooltip } from "reactstrap"
import { navigate } from "gatsby"
import isOnDemand from "../../utils/isOnDemand"
import { SpaceProfileContext } from "../SpaceProfile/context"
import { isSameDay } from "date-fns"

const ListItem = ({
  filter,
  setFilter,
  title = "",
  id,
  initialValue,
  type,
  isActive,
  label,
  user = {},
  className = "",
  faded = false,
  toolTipText,
  toolTipActive,
}) => {
  const {
    commonData: { holidays },
  } = useContext(SpaceProfileContext)
  const [value, setValue] = useState(initialValue)
  const [displayValue, setDisplayValue] = useState(initialValue)

  const formItem = getField(
    type,
    id,
    initialValue,
    setValue,
    setFilter,
    title,
    holidays
  )

  const queryString =
    typeof window !== "undefined" ? qs.parse(window.location.search) : ""

  const toggleFilter = (e) => {
    if (filter) {
      setFilter(null)
    } else {
      setFilter(id)
    }
    e.stopPropagation()
  }

  const showFilter = () => {
    setFilter(filter === id ? null : id)
  }

  useEffect(() => {}, [value, id, isActive, displayValue, queryString])

  useEffect(() => {
    if (id === "current_staff") {
      setDisplayValue(
        Number(initialValue) === 1
          ? "1<span class='d-none d-md-inline-block px-0 ms-1'>person</span>"
          : initialValue +
              "<span class='d-none d-md-inline-block px-0 ms-1'>people</span>"
      )
    } else if (id === "move_in_date") {
      const timeSlot =
        queryString &&
        queryString.on_demand_type === "Hourly" &&
        queryString.start_time &&
        queryString.end_time
          ? `${queryString.start_time} - ${queryString.end_time}`
          : null

      if (queryString && queryString.move_out_date) {
        const startDate = moment(queryString.move_in_date, "YYYY-MM-DD").format(
          "MMM Do"
        )
        const endDate = moment(queryString.move_out_date, "YYYY-MM-DD").format(
          "MMM Do"
        )
        if (
          isSameDay(
            new Date(queryString.move_in_date),
            new Date(queryString.move_out_date)
          )
        ) {
          setDisplayValue(
            `${startDate}${
              timeSlot
                ? `<span class='d-none d-sm-inline-block'>, ${timeSlot}</span>`
                : ""
            }`
          )
        } else {
          setDisplayValue(`${startDate} - ${endDate}`)
        }
      } else {
        setDisplayValue(
          moment(queryString.move_in_date, "YYYY-MM-DD").isValid()
            ? moment(queryString.move_in_date, "YYYY-MM-DD").format("MMMM Do")
            : null
        )
      }
    } else {
      setDisplayValue(value)
    }
  }, [value, id, isActive, displayValue, queryString])

  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)

  const clearFilter = () => {
    const baseUrl = isOnDemand()
      ? process.env.GATSBY_ON_DEMAND_SLUG
      : "locations"
    if (id === "current_staff") {
      navigate(`/${baseUrl}?location=Toronto`)
    } else {
      if (queryString[id]) {
        delete queryString[id]
      }
      if (queryString.move_out_date) {
        delete queryString.move_out_date
      }
      if (queryString.on_demand_type) {
        delete queryString.on_demand_type
      }
      if (queryString.start_time) {
        delete queryString.start_time
      }
      if (queryString.end_time) {
        delete queryString.end_time
      }
      navigate(`/${baseUrl}?${qs.stringify(queryString)}`)
    }
    setFilter()
  }

  return (
    <li
      className={`searchParamsLi ${faded ? "faded" : ""} ${
        isActive ? "active" : ""
      } ${type} ${className}`}
    >
      <span
        onClick={faded ? () => null : showFilter}
        dangerouslySetInnerHTML={{ __html: isActive ? displayValue : label }}
        id={`toolTip_${id}`}
      />
      {toolTipText && toolTipActive && (
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target={`toolTip_${id}`}
          toggle={toggle}
        >
          {toolTipText}
        </Tooltip>
      )}
      {filter === id && (
        <div className={`single-filter`}>
          <img
            src={require("./close.svg").default}
            alt="Close"
            onClick={toggleFilter}
            className={"close-filter d-sm-none"}
          />
          <div className="inner">{formItem}</div>
          {initialValue && (
            <>
              {!(isOnDemand() && id === "current_staff") && (
                <button
                  className={"btn btn-link clear-button"}
                  onClick={clearFilter}
                >
                  Clear
                </button>
              )}
            </>
          )}
        </div>
      )}
    </li>
  )
}
export default ListItem
